import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVoiceover: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="voiceover, sound"><circle cx="12" cy="12" r="9.25" stroke="currentColor" strokeWidth="1.5"/><path d="M8 14.5V9.5H10L11.5 7.5H13V16.5H11.5L10 14.5H8Z" fill="currentColor"/><path d="M14.5 14.5C16.1667 13.25 16.1667 10.75 14.5 9.5" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconVoiceover;
